import { useState, useCallback } from 'react';
import { FareRequest, FareResponse } from '../types/fare';
import { calculateFare, getUserFriendlyError, saveFareHistory } from '../services/fareService';

export function useFareCalculation(userId: string | null) {
  const [loading, setLoading] = useState(false);
  const [fareData, setFareData] = useState<FareResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const calculate = useCallback(async (request: FareRequest) => {
    setLoading(true);
    setError(null);

    try {
      const response = await calculateFare(request);
      setFareData(response);
      
      // Save to history if user is logged in (non-blocking)
      if (userId) {
        saveFareHistory(userId, response).catch(() => {
          // Don't fail the calculation if history save fails
        });
      }
      
      return response;
    } catch (err) {
      const errorMessage = getUserFriendlyError(err);
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [userId]);

  const reset = useCallback(() => {
    setFareData(null);
    setError(null);
    setLoading(false);
  }, []);

  return {
    loading,
    fareData,
    error,
    calculate,
    reset,
  };
}

